import { Form, Input, Typography } from 'antd';

import { RULES_IS_REQUIRE } from '@app/constants';

import type { FormInstance } from 'antd';
import type { FC } from 'react';

const { Text } = Typography;

interface MangoAtcTokenAdditionalComponentsProps {
  form: FormInstance;
  setToken: React.Dispatch<React.SetStateAction<string | null>>;
}

export const MangoAtcTokenAdditionalComponents: FC<
  MangoAtcTokenAdditionalComponentsProps
> = ({ form, setToken }) => {
  const handleFieldsChange = () => {
    const { SignatureKey, AtcUniqCode, VirtualAtcApiAddress } =
      form.getFieldsValue();
    const concatenated = [AtcUniqCode, SignatureKey, VirtualAtcApiAddress].join(
      '.'
    );

    setToken(concatenated);
  };

  return (
    <>
      <div className="item-container">
        <Text strong className="label label-require">
          Уникальный код АТС
        </Text>
        <Form.Item name="AtcUniqCode" rules={[...RULES_IS_REQUIRE]}>
          <Input size="large" onChange={handleFieldsChange} />
        </Form.Item>
      </div>
      <div className="item-container">
        <Text strong className="label label-require">
          Ключ подписи
        </Text>
        <Form.Item name="SignatureKey" rules={[...RULES_IS_REQUIRE]}>
          <Input size="large" onChange={handleFieldsChange} />
        </Form.Item>
      </div>
      <div className="item-container">
        <Text strong className="label label-require">
          Адрес API Виртуальной АТС
        </Text>
        <Form.Item name="VirtualAtcApiAddress" rules={[...RULES_IS_REQUIRE]}>
          <Input size="large" onChange={handleFieldsChange} />
        </Form.Item>
      </div>
    </>
  );
};
